module.exports = __webpack_public_path__ + "img/TW-flag.1dd5684a.svg";